import React from 'react';
import { GridFooterContainer, useGridApiContext } from '@mui/x-data-grid-pro';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * EvidenceComparisonFooter - Custom footer for Evidence Comparison table
 * Left side: Selected rows count
 * Right side: Total rows count
 */
function EvidenceComparisonFooter(props) {
  const {
    selectedRowsCount = 0,
  } = props;

  const apiRef = useGridApiContext();
  const totalRowsCount = apiRef.current.getRowsCount();

  return (
    <GridFooterContainer>
      {/* Left section: Selected rows count and legend */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1, px: 2 }}>
        {selectedRowsCount > 0 && (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {selectedRowsCount} {selectedRowsCount === 1 ? 'row' : 'rows'} selected
          </Typography>
        )}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            aria-hidden
            sx={{
              width: 14,
              height: 14,
              flexShrink: 0,
              boxShadow: 'inset 0 0 0 2px #ffc107',
            }}
          />
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            System Recommended evidence
          </Typography>
        </Box>
      </Box>

      {/* Right section: Total rows count */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {totalRowsCount} {totalRowsCount === 1 ? 'row' : 'rows'}
        </Typography>
      </Box>
    </GridFooterContainer>
  );
}

export default EvidenceComparisonFooter;

